"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRamblerIdHelper = void 0;
const dom_1 = require("@rambler-id/dom");
const react_1 = require("@rambler-id/react");
// NOTE always use production variables in library
const CDN_ORIGIN = 'https://id.rambler.ru';
const CDN_PREFIX = '/rambler-id-helper';
let ramblerIdHelper;
let ramblerIdHelperPromise;
const getRamblerIdHelper = async () => {
    if (!ramblerIdHelper || react_1.isSSR) {
        if (!ramblerIdHelperPromise) {
            ramblerIdHelperPromise = new Promise((resolve, reject) => {
                window.ramblerIdHelper = window.ramblerIdHelper || [];
                window.ramblerIdHelper.push(() => {
                    ramblerIdHelper = window.ramblerIdHelper;
                    resolve();
                });
                (0, dom_1.loadScript)(`${CDN_ORIGIN}${CDN_PREFIX}/auth_events.js`).catch((error) => reject(error));
            });
        }
        try {
            await ramblerIdHelperPromise;
        }
        catch { }
    }
    return ramblerIdHelper;
};
exports.getRamblerIdHelper = getRamblerIdHelper;
//# sourceMappingURL=loader.js.map